// extracted by mini-css-extract-plugin
export default {"button":"Button_button__h-PxG","outline":"Button_outline__wENvs","primary":"Button_primary__YQX3p"};